import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-logo-adaptive-coder',
})
export class SignetLogoAdaptiveCoder {
  /**
   * Destination of the Logo
   */
  @Prop() href =  "http://coder.episource.com";
  
  /**
   * SRC of the logo (Optional)
   */
  @Prop() src =  'https://design.episource.com/img/logo/Product=AC.svg';

  /**
   * Alternative Text
   */
    @Prop() alt =  'Epi Adaptive Coder Logo';

  private getLogoLink(): string {
    return ( this.href );
  }

  private getImageLink(): string {
    return ( this.src );
  }


  private getAltText(): string {
    return ( this.alt );
  }

  render() {
    return (
      <a class='signet-logo-adaptive-coder signet-product-icon' href={this.getLogoLink()}><img src={this.getImageLink()} alt={this.getAltText()} /></a>
    );
  }
}
